export enum ScoreTypes {
  GET_SCORES_BY_COMPANYCODE = "GET_SCORES_BY_COMPANYCODE",
  GET_SCORES_BY_COMPANYCODE_SUCCESS = 'GET_SCORES_BY_COMPANYCODE_SUCCESS',
  GET_SCORES_BY_COMPANYCODE_FAIL = 'GET_SCORES_BY_COMPANYCODE_FAIL'

}
